<span class="user-display">
  <nz-avatar
    [nzSize]="size"
    [nzSrc]="avatarSrc && !avatarError ? avatarSrc : null"
    [nzText]="!avatarSrc || avatarError ? initials : null"
    [nzIcon]="(!avatarSrc || avatarError) && !initials ? 'user' : null"
    [nzAlt]="displayName"
    (nzError)="showFallbackAvatar()">
  </nz-avatar>
  <span *ngIf="showName" class="user-display-name">{{displayName}}</span>
</span>
